"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Lease$ = exports.Lease$outboundSchema = exports.Lease$inboundSchema = void 0;
exports.leaseToJSON = leaseToJSON;
exports.leaseFromJSON = leaseFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
/** @internal */
exports.Lease$inboundSchema = z
    .object({
    calculated_end_of_lease: z.nullable(z.string()),
    calculated_start_of_lease: z.nullable(z.string()),
    date_of_lease: z.nullable(z.string()),
    formatted_lease_term: z.nullable(z.string()),
    lease_term: z.nullable(z.string()),
    lease_term_in_days: z.nullable(z.number().int()),
    remaining_lease_term_in_days: z.nullable(z.number().int()),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "calculated_end_of_lease": "calculatedEndOfLease",
        "calculated_start_of_lease": "calculatedStartOfLease",
        "date_of_lease": "dateOfLease",
        "formatted_lease_term": "formattedLeaseTerm",
        "lease_term": "leaseTerm",
        "lease_term_in_days": "leaseTermInDays",
        "remaining_lease_term_in_days": "remainingLeaseTermInDays",
    });
});
/** @internal */
exports.Lease$outboundSchema = z.object({
    calculatedEndOfLease: z.nullable(z.string()),
    calculatedStartOfLease: z.nullable(z.string()),
    dateOfLease: z.nullable(z.string()),
    formattedLeaseTerm: z.nullable(z.string()),
    leaseTerm: z.nullable(z.string()),
    leaseTermInDays: z.nullable(z.number().int()),
    remainingLeaseTermInDays: z.nullable(z.number().int()),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        calculatedEndOfLease: "calculated_end_of_lease",
        calculatedStartOfLease: "calculated_start_of_lease",
        dateOfLease: "date_of_lease",
        formattedLeaseTerm: "formatted_lease_term",
        leaseTerm: "lease_term",
        leaseTermInDays: "lease_term_in_days",
        remainingLeaseTermInDays: "remaining_lease_term_in_days",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var Lease$;
(function (Lease$) {
    /** @deprecated use `Lease$inboundSchema` instead. */
    Lease$.inboundSchema = exports.Lease$inboundSchema;
    /** @deprecated use `Lease$outboundSchema` instead. */
    Lease$.outboundSchema = exports.Lease$outboundSchema;
})(Lease$ || (exports.Lease$ = Lease$ = {}));
function leaseToJSON(lease) {
    return JSON.stringify(exports.Lease$outboundSchema.parse(lease));
}
function leaseFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.Lease$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'Lease' from JSON`);
}
//# sourceMappingURL=lease.js.map